/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-15 17:10:54
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-07-14 15:58:22
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/TermsAndConditionsSelection/index.tsx
 */
import React from 'react';
import css from './css.module.less';

import WhiteBackgroundTooltip, {
  TooltipContainer,
  TooltipContent,
} from '@/src/components/GlobalTooltip/WhiteBackgroundTooltip';
import { Modal, ModalFooter, OriCheckbox } from 'src/components/Antd';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { Tag } from 'src/components/Tags/Tags';
import { useI18n } from 'src/hooks/useRouterChange';
import { useItemsChange } from 'src/tools/hooks/useItemChangeWithOrder';
import { i18nGet } from 'src/tools/tools';

const TCModals = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    tcs = [],
    selectedItems,
    onOk,
    onCancel,
    visible,
    title,
    ...rest
  } = props;

  const {
    onOk: onOkPress,
    onSelectChange,
    selectedRowKeys,
  } = useItemsChange(selectedItems, tcs, onOk, onCancel);

  return (
    <Modal
      className={css.modalContainer}
      visible={visible}
      title={title || getI18n('general.editTermsConditions')}
      onCancel={onCancel}
      {...rest}>
      <OriCheckbox.Group
        className={css.checkGroup}
        value={selectedRowKeys.map((i) => i.uuid)}
        onChange={onSelectChange}>
        {tcs.map((tc) => {
          const { name, contentAbbreviation, uuid, consentAttributes } = tc;
          return (
            <Item
              key={uuid}
              uuid={uuid}
              name={name}
              content={contentAbbreviation}
              consentAttributes={consentAttributes || []}
            />
          );
        })}
      </OriCheckbox.Group>
      <ModalFooter
        okText={getI18n('general.confirm')}
        cancelText={getI18n('general.discard')}
        onOk={onOkPress}
        onCancel={onCancel}
      />
    </Modal>
  );
};
export default TCModals;
const Item = (props) => {
  const { name, content, uuid, consentAttributes } = props;
  const hasAtt = consentAttributes.length > 0;
  return (
    <div className={css.itemContainer}>
      <OriCheckbox value={uuid}>
        <div className={css.labelContainer}>
          <div className={css.nameContainer}>
            <WhiteBackgroundTooltip
              color={'#000'}
              title={
                <TooltipContainer>
                  <TooltipContent style={{ color: '#fff' }}>
                    {name}
                  </TooltipContent>
                </TooltipContainer>
              }
              placement='bottom' //overlayClassName
            >
              {name}
            </WhiteBackgroundTooltip>
          </div>
          <div className={css.remarksContainer}>
            {' '}
            <WhiteBackgroundTooltip
              color={'#000'}
              title={
                <TooltipContainer>
                  <TooltipContent style={{ color: '#fff' }}>
                    {content}
                  </TooltipContent>
                </TooltipContainer>
              }
              placement='bottom' //overlayClassName
            >
              {content}
            </WhiteBackgroundTooltip>
          </div>
          {hasAtt && (
            <div className={css.attContainer}>
              {consentAttributes.map((i, index) => {
                return (
                  <Tag className={css.tag} closable={false} key={index}>
                    <NoWrapContainer>
                      <Tooltip title={i}>{i}</Tooltip>
                    </NoWrapContainer>
                  </Tag>
                );
              })}
            </div>
          )}
        </div>
      </OriCheckbox>
    </div>
  );
};
